export default __webpack_public_path__ + "static/media/correspondent4.ce9d7533.png";